module.exports = "images/france-5.d21ac70d.png";